import { Button, Typography } from "@material-ui/core";
import React from "react";
import { gridTitleStyles } from "./GridTitleStyles";
import clsx from "clsx";
import { observer } from "mobx-react";

export default observer(function DynamicGridTitle(props: DynamicGridProps) {
    const classes = gridTitleStyles();

    return (
        <Typography>
            <Button className={classes.button} onClick={props.firstOnClick}>
                <Typography
                    className={clsx(classes.title, {
                        [classes.selectedTitle]: props.firstStyle,
                        [classes.unselectedTitle]: !props.firstStyle,
                    })}
                    variant="h4"
                >
                    {props.firstTitle}
                </Typography>
            </Button>

            <Button className={classes.button} onClick={props.secondOnClick}>
                <Typography
                    className={clsx(classes.title, {
                        [classes.selectedTitle]: props.secondStyle,
                        [classes.unselectedTitle]: !props.secondStyle,
                    })}
                    variant="h4"
                >
                    {props.secondTitle}
                </Typography>
            </Button>

            <Typography className={classes.subText}>{props.subText}</Typography>
        </Typography>
    );
});

interface DynamicGridProps {
    firstTitle: string;
    secondTitle: string;
    firstStyle: boolean;
    secondStyle: boolean;
    subText: string;
    firstOnClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
    secondOnClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}
